import React from 'react'

function Footer() {
  return (
    <div className="absolute bottom-0 w-full p-6 pb-14">
        <p className="text-center">© 2022 <span className='gradientText'>Anthony Hong</span>. All rights reserved.</p>
    </div>
  )
}

export default Footer